import React from 'react'

import ElementField from 'src/components/ElementField'

const CreditCard = ({
  i18n, stripeElements, donation, errors,
  show_input_labels, resetStripeErrors,
}) => {
  const showInputLabels = show_input_labels || donation.collectAddress

  return (
    <ElementField
      stripeElements={stripeElements}
      errors={errors}
      label={i18n.t('card_details')}
      labelClass={showInputLabels ? 'form-label' : 'visually-hidden'}
      resetStripeErrors={resetStripeErrors}
    />
  )
}

export default CreditCard
